import type { OrderProduct } from "../OrderProduct.js";
import type { ProductAmountPerCategory } from "../ProductAmountPerCategory.js";
import { maxProductQuantityInCart } from "../maxProductQuantityInCart.js";

export function areProductQuantitiesOverMax(
	products: OrderProduct[],
	maxProductsPerCategory: ProductAmountPerCategory,
): boolean {
	const productsPerCategoryInOrder: ProductAmountPerCategory = {};
	for (const product of products) {
		for (const categoryId of product.product.categoryIds) {
			productsPerCategoryInOrder[categoryId] = (productsPerCategoryInOrder[categoryId] ?? 0) + product.quantity;
		}
	}

	for (const [categoryId, count] of Object.entries(productsPerCategoryInOrder)) {
		if (count > (maxProductsPerCategory[categoryId] ?? maxProductQuantityInCart)) {
			return true;
		}
	}

	return false;
}
